export default "<block-ui [message]=\"'Please wait...'\">\n    <router-outlet ></router-outlet>\n</block-ui>";